module.exports = __webpack_public_path__ + "static/media/xiangyangshan_mobile.89ad9a00.webp";